// extracted by mini-css-extract-plugin
export default {"invoice":"Invoice_invoice__quOpI","accordion":"Invoice_accordion__Gzlrz","accordion_header":"Invoice_accordion_header__oacSa"};